import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { CheckoutDesignerIcon } from '@dev/ee-components';
import { OpenGallery } from '@/store/checkoutCreator/actions';
import { ContentBox } from '@/assets/ContentBox';
import { TemplatesGallery } from '../../components/TemplatesGallery';

export const Step2EditContent = (): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const openTemplatesGallery = (): void => {
        dispatch(OpenGallery());
    };

    return (
        <>
            <ContentBox
                id="checkout-creator-gallery-box"
                icon={<CheckoutDesignerIcon width="100%" />}
                title={t('checkoutstartdesigning')}
                description={t('checkoutchoosefromgallery')}
                onBoxClick={openTemplatesGallery}
            />
            <TemplatesGallery />
        </>
    );
};
